import React from 'react';
import { fmtDate } from '@/lib/utils';
import { Trophy } from 'lucide-react';
import TierAvatar from '@/components/account/TierAvatar';

// One row in the customer directory. Uses the precomputed per-email stats
// (lifetime earned → tier, spend, points balance, order count) so the
// directory doesn't fire a ledger query per customer.
export default function CustomerDirectoryRow({ user, stats, tags = [], onOpen }) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.full_name || '—';
  const tier = stats.tier;
  const date = fmtDate(user.created_date) || '—';

  return (
    <div
      onClick={() => onOpen(user)}
      className="flex flex-col sm:grid sm:grid-cols-12 gap-2 sm:gap-4 px-4 sm:px-6 py-4 border-b border-white/5 hover:bg-white/5 transition-colors sm:items-center cursor-pointer"
    >
      {/* NAME + avatar + tier trophy */}
      <div className="sm:col-span-3 flex items-center gap-3 min-w-0">
        <TierAvatar email={user.email} profilePictureUrl={user.profile_picture_url} tier={tier} size={40} />
        <div className="min-w-0">
          <p className="text-white text-sm font-medium truncate">{name}</p>
          <p className="text-white/30 text-xs truncate sm:hidden">{user.email}</p>
          {(user.tags || []).length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1">
              {(user.tags || []).slice(0, 3).map((k) => {
                const def = tags.find((t) => t.key === k);
                const color = def?.color || '#c0392b';
                return (
                  <span key={k} className="text-[8px] font-bold tracking-wider px-1.5 py-0.5 border" style={{ color, borderColor: color + '55' }}>
                    {def?.label || k}
                  </span>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* EMAIL (desktop) */}
      <p className="hidden sm:block sm:col-span-3 text-white/50 text-sm truncate">{user.email}</p>

      {/* TIER */}
      <div className="sm:col-span-2 flex items-center justify-between sm:justify-start gap-2">
        <span className="text-white/30 text-[9px] font-bold tracking-widest sm:hidden">TIER</span>
        <span
          className="inline-flex items-center gap-1 text-[10px] font-bold tracking-wider px-2 py-0.5 border"
          style={{ color: tier.color, borderColor: tier.color + '55' }}
        >
          <Trophy className="w-3 h-3" style={{ color: tier.color }} />
          {tier.name.toUpperCase()}
        </span>
      </div>

      {/* SPEND */}
      <div className="sm:col-span-2 flex items-center justify-between sm:justify-start gap-2">
        <span className="text-white/30 text-[9px] font-bold tracking-widest sm:hidden">LIFETIME SPEND</span>
        <span className="text-white/80 text-sm font-bold">£{Number(stats.totalSpend || 0).toFixed(2)}</span>
      </div>

      {/* POINTS */}
      <div className="sm:col-span-1 flex items-center justify-between sm:justify-start gap-2">
        <span className="text-white/30 text-[9px] font-bold tracking-widest sm:hidden">POINTS</span>
        <span className="text-white/70 text-sm">{stats.pointsBalance || 0}</span>
      </div>

      {/* JOINED */}
      <div className="sm:col-span-1 flex items-center justify-between sm:justify-start gap-2">
        <span className="text-white/30 text-[9px] font-bold tracking-widest sm:hidden">JOINED</span>
        <span className="text-white/30 text-xs">{date}</span>
      </div>
    </div>
  );
}